import { SubscriptionPolicy } from 'modules/graphql';
import { ApiMethod } from 'services/api';
import { UseRestMutationOptions, useRestMutation, useRestQuery } from 'utils/hooks/api';

export type FrequencyCap = {
  numMessagesInPeriod: number;
  period?: string;
  periodDays: number;
  ignoreFrequencyCap?: boolean;
};

export type DoubleOptInMetadata = {
  brandName?: string;
  messagingInitiative?: string[];
  disclaimerLink?: string;
  smsSenderId?: number;
};

export type MessageType = {
  id: number;
  createdAt: number;
  updatedAt: number;
  name: string;
  messageChannelId: number; // Foreign key mapping to Channel id
  projectId: number;
  subscriptionPolicy: SubscriptionPolicy;
  rateLimitPerMin?: number;
  frequencyCap?: FrequencyCap;
  // Specific to SMS Double Opt In message types
  subscriptionPolicyMetadata?: DoubleOptInMetadata;
};

export const MESSAGE_TYPE_JSON = '/settings/messageTypes.json';
export const CREATE_MESSAGE_TYPE_URL = '/settings/messageTypes/create';
export const DELETE_MESSAGE_TYPE_URL = '/settings/messageTypes/delete';
export const UPDATE_MESSAGE_TYPE_URL = '/settings/messageTypes/update';
export const MIGRATE_MESSAGE_TYPE_URL = '/settings/messageTypes/migratetodoubleoptin';

export const useMessageTypesQuery = () => useRestQuery(MESSAGE_TYPE_JSON);

export const useCreateMessageTypeMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_MESSAGE_TYPE_URL, ApiMethod.post, options);

export const useUpdateMessageTypeMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_MESSAGE_TYPE_URL, ApiMethod.post, options);

export const useUpdateRateLimitMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_MESSAGE_TYPE_URL, ApiMethod.post, options);

export const useUpdateFrequencyCapMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_MESSAGE_TYPE_URL, ApiMethod.post, options);

export const useDeleteMessageTypeMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(DELETE_MESSAGE_TYPE_URL, ApiMethod.post, options);

export const useMigrateMessageTypeMutation = (options?: UseRestMutationOptions) =>
  useRestMutation(MIGRATE_MESSAGE_TYPE_URL, ApiMethod.post, options);
